<script>
  import { _ } from "svelte-i18n";
  import { createEventDispatcher } from "svelte";
  const dispatch = createEventDispatcher();

  export let value;
  export let disabled;
  export let label;
</script>

<label class="switch">
  <input
    type="checkbox"
    bind:checked={value}
    on:change={(e) => dispatch("change", e.target.checked)}
    {disabled}
  />
  <span class="slider round" />
</label>

<span class="ml-3">{label}</span>

<style>
  .switch {
    position: relative;
    display: inline-block;
    width: 50px;
    height: 24px;
  }

  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: var(--gl-control-border-color);
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .slider:hover {
    background-color: var(--gl-hover);
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 16px;
    width: 16px;
    left: 4px;
    bottom: 4px;
    background-color: black;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  input:checked + .slider {
    background-color: var(--gl-primary);
  }

  input:checked:hover + .slider {
    background-color: var(--gl-primary-ter);
  }

  input:focus + .slider {
    box-shadow: 0 0 1px var(--gl-primary);
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }

  input:not(:checked) + .slider:before {
    background-color: white;
  }

  input:disabled + .slider {
    background-color: var(--gl-disabled);
  }

  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
  }

  .slider.round:before {
    border-radius: 50%;
  }
</style>
